import { giphyDarkestGrey } from '@giphy/js-brand'
import React from 'react'
import { useInView } from 'react-intersection-observer'
import withLocationState from 'shared/components/with-location-state'
import { grid12 } from 'shared/util/grid'
import styled from 'styled-components'

const Banner = styled.img`
    width: ${grid12}px;
    height: 518px;
    margin: 10px 0 30px;
`

const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
`

const itemWidth = (grid12 - 16 * 3) / 4
const ItemContainer = styled.a`
    width: ${itemWidth}px;
    height: 311px;
    margin: 0 16px 16px 0;
    background: ${giphyDarkestGrey};
    padding: 15px;
    box-sizing: border-box;
    h4 {
        text-transform: uppercase;
        font-weight: 700;
        margin: 10px 0 4px 0;
    }
    p {
        font-size: 12px;
        line-height: 16px;
        height: 150px;
        overflow: hidden;
    }
    img {
        width: 217px;
        height: 141px;
    }
    &:nth-child(4n) {
        margin-right: 0;
    }
`

type Project = {
    title: string
    url: string
    description: string
    image: string
}
const placeholder = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
const Item = ({ project }: { project: Project }) => {
    const [ref, inView] = useInView()
    return (
        <ItemContainer href={project.url} ref={ref}>
            <img src={inView ? project.image : placeholder} />
            <h4>{project.title}</h4>
            <p>{project.description}</p>
        </ItemContainer>
    )
}
const Labs = ({ projects }: { projects: Project[] }) => {
    return (
        <>
            <Banner src="https://giphy.com/static/img/labs.gif" />
            <Container>
                {projects.map((p) => (
                    <Item key={p.title} project={p} />
                ))}
            </Container>
        </>
    )
}
export default withLocationState(['projects'])(Labs)
